import { Quaternion } from "three";
export function getSection(id, sections) {
  for (let i = 0; i < sections.length; i++) {
    if (sections[i].id === id) {
      return sections[i];
    }
  }
  throw new Error("Section id '".concat(id, "' is not defined in the NFold configuration!"));
}
export function rotateVector(edge, pivot, rotation) {
  let result = edge.sub(pivot);
  result = result.applyEuler(rotation);
  result = result.add(pivot);
  return result;
}
export function applyRotation(panel, rotationPoint, rotationAngle, rotationAxis) {
  const quaternion = new Quaternion();
  quaternion.setFromAxisAngle(rotationAxis, rotationAngle);
  panel.quaternion.multiplyQuaternions(quaternion, panel.quaternion);
  panel.position.sub(rotationPoint);
  panel.position.applyQuaternion(quaternion);
  panel.position.add(rotationPoint);
  return panel;
}